import 'semantic-ui-css/semantic.min.css';

import 'app/styles/style.scss';

import { connect } from 'react-redux';
import React from 'react';
import * as pt from 'prop-types';
import * as _ from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import Select from 'react-select';

import ApiCalls from '../../utils/apiCalls';
import RegionsFilter from '../RegionsFilter';
import OptionWithPatientData from '../OptionWithPatientData';
import { ANIMAL_SEARCH_STYLE } from 'app/components/AnimalSearch/AnimalSearchSelectStyle';
import { selectLoggedIn } from 'app/redux/global/selectors';
import DateInput from 'app/components/Form/DateInput';

class AnimalSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileIdOptions: [],
      ownersOptions: [],
      animalsOptions: [],
      ownerId: undefined,
      animalId: undefined,
    };
  }

  /* eslint-disable react/destructuring-assignment */
  setAnimalId = (...args) => this.props.setAnimalId(...args);

  setOwnerId = (...args) => this.props.setOwnerId(...args);
  /* eslint-enable react/destructuring-assignment */

  onAnimalNameChange = (e, { action }) => {
    if (action === 'input-change') {
      this.getAnimalNameCompletion(e);
    }
  };

  validateAnimalName = (animal) => {
    if (animal != null) {
      const { _id: animalId } = animal.data;
      this.setState({ animalId }, () => {
        this.setAnimalId(animalId);
        this.getOwnerNameCompletion('');
      });
    } else {
      this.setState({ animalId: null }, () => {
        this.setAnimalId(null);
      });
    }
  };

  getAnimalNameCompletion = (animalNameEntered) =>
    ApiCalls.getAnimalNameCompletion({
      animal_name: animalNameEntered || '',
      owner_id: this.state.ownerId,
    }).then(({ data: { animals } }) => {
      this.setAnimalsOptions(animals);
    });

  onFileIdChange = (fileId, { action }) => {
    if (action === 'input-change') {
      ApiCalls.getAnimalNameCompletion({
        file_id: fileId || '',
      }).then(({ data: { animals } }) => {
        this.setState({
          fileIdOptions: animals.map((animal) => ({
            value: animal.file_id,
            label: animal.file_id,
            data: animal,
          })),
        });
      });
    }
  };

  setFileId = (fileId) => {
    const { setFileId } = this.props;
    setFileId(_.get(fileId, 'value'));
  };

  onOwnerNameChange = (e, { action }) => {
    if (action === 'input-change') {
      this.getOwnerNameCompletion(e);
    }
  };

  validateOwnerName = (owner) => {
    if (owner != null) {
      const { _id: ownerId } = owner.data;
      // eslint-disable-next-line no-underscore-dangle
      this.setState({ ownerId }, () => {
        this.setOwnerId(ownerId);
        if (!this.state.animalId) this.getAnimalNameCompletion();
      });
    } else {
      this.setState({ ownerId: null }, () => {
        this.setOwnerId(null);
      });
    }
  };

  getOwnerNameCompletion = (ownerNameEntered) => {
    ApiCalls.getOwnerNameCompletion({
      owner_name: ownerNameEntered,
      animal_id: this.state.animalId,
    }).then(({ data: { owners } }) => {
      this.setOwnersOptions(owners);
    });
  };

  setAnimalsOptions = (animals) =>
    this.setState({
      animalsOptions: animals.map((animal) => ({
        label: animal.name,
        value: animal.name,
        data: animal,
      })),
    });

  setOwnersOptions = (owners) =>
    this.setState({
      ownersOptions: owners.map((owner) => ({
        label: owner.name,
        value: owner.name,
        data: owner,
      })),
    });

  render() {
    const { ownersOptions, animalsOptions, fileIdOptions } = this.state;
    const { intl, startDate, endDate, onChooseStartDate, onChooseEndDate, setRegions, disabled } =
      this.props;
    return (
      <div className="animal-search">
        <div className="field owner">
          <Select
            styles={ANIMAL_SEARCH_STYLE}
            isClearable
            id="ownerName"
            name="ownerName"
            placeholder={intl.formatMessage({ id: 'monitoring.owner' })}
            noOptionsMessage={() => null}
            onInputChange={this.onOwnerNameChange}
            options={ownersOptions}
            onChange={this.validateOwnerName}
            isDisabled={disabled}
          />
        </div>
        <div className="field animal">
          <Select
            styles={ANIMAL_SEARCH_STYLE}
            isClearable
            id="animalName"
            placeholder={intl.formatMessage({ id: 'monitoring.animal' })}
            noOptionsMessage={() => null}
            onInputChange={this.onAnimalNameChange}
            options={animalsOptions}
            onChange={this.validateAnimalName}
            components={{ Option: OptionWithPatientData('name') }}
            isDisabled={disabled}
          />
        </div>
        <div className="field">
          <Select
            styles={ANIMAL_SEARCH_STYLE}
            isClearable
            id="idFile"
            placeholder={intl.formatMessage({ id: 'monitoring.id' })}
            onInputChange={this.onFileIdChange}
            onChange={this.setFileId}
            options={fileIdOptions}
            noOptionsMessage={() => null}
            components={{ Option: OptionWithPatientData('file_id') }}
            isDisabled={disabled}
          />
        </div>
        <DateInput
          value={startDate}
          onChange={(date) => onChooseStartDate(date)}
          data-testid="start-date"
          label={<FormattedMessage id="date.from" />}
          disabled={disabled}
        />
        <DateInput
          value={endDate}
          onChange={(date) => onChooseEndDate(date)}
          data-testid="start-date"
          label={<FormattedMessage id="date.to" />}
          disabled={disabled}
        />
        <div className="field regions" style={{ marginBottom: '1em' }}>
          <RegionsFilter setRegions={setRegions} isDisabled={disabled} />
        </div>
      </div>
    );
  }
}

AnimalSearch.propTypes = {
  setAnimalId: pt.func,
  setOwnerId: pt.func,
  setFileId: pt.func,
  disabled: pt.bool,
};

AnimalSearch.defaultProps = {
  setAnimalId: () => {},
  setOwnerId: () => {},
  setFileId: () => {},
  disabled: false,
};

export default injectIntl(AnimalSearch);
